// extracted by mini-css-extract-plugin
module.exports = {"ssl_img":"Footer_ssl_img___8SoD","rr_logo":"Footer_rr_logo__KgSMb"};